import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import InitialOrder from './initialorder';
import PreviewOrder from './previeworder';
import SuccessOrder from './successorder';
import FiatQuote from './fiatquote';
import ToastHandler from '../../components/toasthandler';
import Loader from '../../components/loader';
import LoaderRing from '../../components/loaderring';
import AssetConfig from '../../components/assetconfig';
import Modal from '../../components/modal';

import * as Sentry from '@sentry/react';

import {
  fetchBalance,
  fetchExchangeRate,
  fetchAssetValue,
  fetchQuote,
  createOtcOrder,
  fetchTradeFees
} from '../../actions';

const qs = require('query-string');

class Instant extends Component {
  constructor(props) {
    super(props);
    const filterParams = qs.parse(this.props.location.search);
    this.state = {
      filterParams,
      modalComponent: null,
      sideBar: null,
      darkModal: null,
      otcPairs: {},
      otcAssets: [],
      assetPairs: [],
      aAssets: [],
      bAssets: [],
      tradeType: 'BUY',
      tradeStage: 1,
      tradeAmount: '',
      tradeSpend: '',
      promoCode: '',
      pristine: true,
      exchA: 'GOLD',
      exchB: 'BTC',
      useExchA: 'GOLD',
      useExchB: 'BTC',
      pair: 'GOLDBTC',
      humPair: 'GOLD/BTC',
      tradeAlt: false,
      fiatEnabled: false,
      fiatSelected: false,
      tradeSuccess: false,
      countdownExpired: false,
      exchangeLoading: true,
      balanceLoading: true,
      feesLoading: true,
      feesFail: false,
      latestChange: '',
      availableSpend: true,
      otcFail: false,
      submitLoading: false,
    };
    this.toggleModal = this.toggleModal.bind(this);
    this.amountChange = this.amountChange.bind(this);
    this.assetsInitial = this.assetsInitial.bind(this);
    this.assetChange = this.assetChange.bind(this);
    this.handlePair = this.handlePair.bind(this);
    this.checkOrder = this.checkOrder.bind(this);
    this.submitOrder = this.submitOrder.bind(this);
    this.newOrder = this.newOrder.bind(this);
    this.editOrder = this.editOrder.bind(this);
    // this.otcFooter = this.otcFooter.bind(this);
    this.checkCountdown = this.checkCountdown.bind(this);
    this.getQuoteFiat = this.getQuoteFiat.bind(this);
    this.updateDataLooped = this.updateDataLooped.bind(this);
    this.exchangeRate = this.exchangeRate.bind(this);
    this.handleAssetValue = this.handleAssetValue.bind(this);
    this.isOfType = this.isOfType.bind(this);
    this.humName = this.humName.bind(this);
    this.currencySign = this.currencySign.bind(this);
    this.availableBalance = this.availableBalance.bind(this);
    this.takerTiers = this.takerTiers.bind(this);
    this.hasEnoughBalance = this.hasEnoughBalance.bind(this);
    this.getOtcDefaults = this.getOtcDefaults.bind(this);
    this.promoChange = this.promoChange.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    const { pair } = this.state;
    this.assetsInitial();
    dispatch(fetchBalance({})).then(res => {
      if (res.type === 'FETCH_BALANCES_SUCCESS') {
        this.setState({ balanceLoading: false });
      }
    });
    this.exchangeRate();
    this.handleAssetValue();
    const numInputs = document.querySelectorAll('input[type="number"]');
    numInputs.forEach(function(elem) {
      elem.addEventListener('keypress', function (e) {
        if (e.keyCode === 8 || e.key === '.') { return }
        if (e.keyCode < 48 || e.keyCode > 57)
        { e.preventDefault(); }
      });
    });
    dispatch(fetchTradeFees()).then(res => {
      if (res.type === 'FETCH_TRADE_FEES_SUCCESS') {
        this.setState({ feesLoading: false });
      }
      if (res.type === 'FETCH_TRADE_FEES_FAIL') {
        this.setState({ feesLoading: false, feesFail: true });
      }
    });
  }

  componentWillUnmount() {
    const numInputs = document.querySelectorAll('input[type="number"]');
    numInputs.forEach(function(elem) {
      elem.removeEventListener('keypress', function (e) {
        if (e.keyCode === 8 || e.key === '.') { return }
        if (e.keyCode < 48 || e.keyCode > 57)
        { e.preventDefault(); }
      });
    });
  }

  toggleModal(component, sideBar, darkModal) {
    this.setState({
      modalComponent: component,
      sideBar,
      darkModal,
    });
  }

  getQuoteFiat(type) {
    if (type === 'BUY') {
      this.setState({ tradeStage: 4, testLoading: true });
      setTimeout(() => {
        this.setState({ testLoading: false });
      }, 1000);
    }

    if (type === 'SELL') {
      this.setState({ tradeStage: 4, testLoading: true });
      setTimeout(() => {
        this.setState({ testLoading: false });
      }, 1000);
    }
  }

  exchangeRate(fetchPair) {
    const { tradeAlt, tradeAmount, tradeSpend, pair, tradeType } = this.state;
    const { dispatch } = this.props;

    let usePair;
    let useType;
    if (pair) {
      usePair = pair;
    }
    if (tradeType) {
      useType = tradeType;
    }
    if (fetchPair) {
      if (fetchPair.pair) {
        usePair = fetchPair.pair;
      }
      if (fetchPair.tradeType) {
        useType = fetchPair.tradeType;
      }
    }
    let quoteData;
    if (tradeType === 'BUY') {
      quoteData = {
        captcha: 123,
        pair: usePair,
        type: useType,
        quantity: Number(1),
      };
    }
    if (tradeType === 'SELL') {
      quoteData = {
        captcha: 123,
        pair: usePair,
        type: useType,
        quantity: Number(1),
      };
    }
    dispatch(fetchExchangeRate(quoteData)).then((res) => {
      if (res.type === 'FETCH_EXCHANGE_RATE_SUCCESS') {
        this.setState({ exchangeLoading: false });
      }
    });
  }

  handleAssetValue(fetchPair) {
    const { useExchA, useExchB } = this.state;
    const { dispatch, user } = this.props;

    let assetExchA;
    let assetExchB;

    if (useExchA) {
      assetExchA = useExchA;
    }
    if (useExchB) {
      assetExchB = useExchB;
    }
    if (fetchPair) {
      if (fetchPair.useExchA) {
        assetExchA = fetchPair.useExchA;
      }
      if (fetchPair.useExchB) {
        assetExchB = fetchPair.useExchB;
      }
    }
    let curr;
    if (user && user.me && user.me.defaults && user.me.defaults.currencyHandle) {
      curr = user.me.defaults.currencyHandle;
    }
    let useCurr;
    switch (curr) {
      case 'CENT':
        useCurr = 'USD';
        break;
      case 'EURCENT':
        useCurr = 'EUR';
        break;
      default:
        useCurr = 'EUR';
        break;
    }

    let usePair;
    if (assetExchB && useCurr) {
      usePair = useCurr + assetExchB;
    }

    const assetData = {
      pair: usePair.toUpperCase(),
    };

    dispatch(fetchAssetValue(assetData)).then((res) => {
      if (res.type === 'FETCH_ASSET_VALUE_SUCCESS') {
        this.setState({ assetPriceLoading: false });
      }
    });
  }

  updateDataLooped() {
    const { dispatch } = this.props;
    const { pair } = this.state;
    this.exchangeRate();
    this.handleAssetValue();
  }

  assetsInitial() {
    const { assets, pairs } = this.props;
    const { exchA, fiatEnabled } = this.state;

    const otcPairs = {};
    const assetPairs = [];
    let allAssets = [];
    let uniqueAssets = [];
    const frontEnabled = [];
    let useAssets = [];
    let useAssetPairs = [];
    if (pairs && Object.keys(pairs).length) {
      Object.keys(pairs).forEach((key) => {
        if (pairs[key] && pairs[key].permissions) {
          if (pairs[key].permissions.includes('OTC')) {
            otcPairs[key] = pairs[key];
          }
        }
      });
    }
    if (otcPairs && Object.keys(otcPairs).length) {
      Object.keys(otcPairs).forEach((key) => {
        if (otcPairs[key] && otcPairs[key].alt) {
          assetPairs.push(otcPairs[key].alt.split(':'));
        }
      });
      allAssets = [].concat.apply([], assetPairs);
      uniqueAssets = [...new Set(allAssets)];
    }
    if ((AssetConfig && AssetConfig.length)) {
      AssetConfig.map((asset) => {
        if (asset.enabled) {
          frontEnabled.push(asset.handle);
        }
      });
    }
    if ((uniqueAssets && uniqueAssets.length) && (frontEnabled && frontEnabled.length)) {
      useAssets = uniqueAssets.filter((asset) => {
        return frontEnabled.includes(asset);
      });
    }

    let otcAssets;
    let aAssets;
    let bAssets;
    if ((assets && assets.length) && (useAssets && useAssets.length)) {
      otcAssets = assets
        .filter((asset) => {
          return useAssets.includes(asset.handle);
        })
        .map((asset) => {
          return (
            {
              name: asset.name.toUpperCase(),
              asset: asset.handle,
              defaults: asset.defaults,
            }
          );
        });
    }

    if (otcAssets && otcAssets.length) {
      aAssets = [...otcAssets];
      bAssets = [...otcAssets];
    }

    if (aAssets && bAssets) {
      this.setState({ otcPairs, otcAssets, assetPairs, aAssets, bAssets });
    }
  }

  assetChange(event) {
    const { dispatch } = this.props;
    const { exchA, exchB, fiatEnabled, pair, otcAssets, aAssets, bAssets, assetPairs } = this.state;

    const frontEnabled = [];
    if ((AssetConfig && AssetConfig.length)) {
      AssetConfig.map((asset) => {
        if (asset.enabled) {
          frontEnabled.push(asset.handle);
        }
      });
    }

    let usePair;
    let aAssetsNew;
    let bAssetsNew;
    if (aAssets) {
      aAssetsNew = [...otcAssets];
    }
    if (bAssets) {
      bAssetsNew = [...otcAssets];
    }

    let targetA = event.target;
    let targetB = event.target;

    if (event.invert === true) {
      targetA = event.targetA;
      targetB = event.targetA;
    }

    let notSelectedA;
    let notSelectedB;
    let selectedPair;
    let allowedPairs;

    let useExchB = exchB;
    let useExchA = exchA;

    if (targetA.id === 'exchA') {
      // does selected pair exist in OTC enabled pairs
      selectedPair = assetPairs.find(function(pair) {
        return (pair.includes(targetA.value) && pair.includes(exchB) && (targetA.value !== exchB));
      });
      // list of OTC enabled pairs including selected asset
      allowedPairs = assetPairs.filter(function(pair) {
        let pairIncludesAsset = false;
        if (targetA.value) {
          pairIncludesAsset = pair.includes(targetA.value)
        }
        let pairA;
        let pairB;
        if (pair[0]) {
          pairA = pair[0];
        }
        if (pair[1]) {
          pairB = pair[1];
        }
        let pairAFrontEnabled;
        let pairBFrontEnabled;
        if (pairA) {
          pairAFrontEnabled = frontEnabled.includes(pairA)
        }
        if (pairB) {
          pairBFrontEnabled = frontEnabled.includes(pairB)
        }
        const validPairs = pairIncludesAsset && pairAFrontEnabled && pairBFrontEnabled;
        return validPairs;
      });
      if (!selectedPair) {
        notSelectedB = allowedPairs[0].find(function(asset) {
          return (asset !== exchB && asset !== targetA.value);
        });
        if (notSelectedB) {
          useExchB = notSelectedB;
        }
      }

      usePair = [targetA.value.toUpperCase(), useExchB.toUpperCase()];

      if (aAssetsNew && bAssetsNew) {
        this.setState({
          aAssets: aAssetsNew,
          bAssets: bAssetsNew,
          exchA: targetA.value,
          exchB: useExchB,
          tradeSpend: '',
          tradeAmount: '',
          pristine: true,
          availableSpend: true,
        });
      }
    }

    if (targetB.id === 'exchB') {
      // does selected pair exist in OTC enabled pairs
      selectedPair = assetPairs.find(function(pair) {
        return (pair.includes(targetB.value) && pair.includes(exchA) && (targetB.value !== exchA));
      });
      // list of OTC enabled pairs including selected asset

      allowedPairs = assetPairs.filter(function(pair) {
        let pairIncludesAsset = false;
        if (targetB.value) {
          pairIncludesAsset = pair.includes(targetB.value)
        }
        let pairA;
        let pairB;
        if (pair[0]) {
          pairA = pair[0];
        }
        if (pair[1]) {
          pairB = pair[1];
        }
        let pairAFrontEnabled;
        let pairBFrontEnabled;
        if (pairA) {
          pairAFrontEnabled = frontEnabled.includes(pairA)
        }
        if (pairB) {
          pairBFrontEnabled = frontEnabled.includes(pairB)
        }
        const validPairs = pairIncludesAsset && pairAFrontEnabled && pairBFrontEnabled;
        return validPairs;
      });

      if (!selectedPair) {
        notSelectedA = allowedPairs[0].find(function(asset) {
          return (asset !== exchA && asset !== targetB.value);
        });
        if (notSelectedA) {
          useExchA = notSelectedA;
        }
      }

      usePair = [useExchA.toUpperCase(), targetB.value.toUpperCase()];

      if (aAssetsNew && bAssetsNew) {
        this.setState({
          aAssets: aAssetsNew,
          bAssets: bAssetsNew,
          exchA: useExchA,
          exchB: targetB.value,
          tradeSpend: '',
          tradeAmount: '',
          pristine: true,
          availableSpend: true,
        });
      }
    }
    const fetchPair = this.handlePair(usePair);
    this.exchangeRate(fetchPair);
    this.handleAssetValue(fetchPair);
  }

  handlePair(pair) {
    const { pairs, assets } = this.props;
    const { otcPairs, otcAssets } = this.state;

    const usePair = pair[0] + pair[1];
    const revPair = pair[1] + pair[0];
    let tradeType;

    let otcPair;
    if (otcPairs && Object.keys(otcPairs).length) {
      otcPair = otcPairs[usePair];
      if (otcPair) {
        tradeType = 'BUY';
      }
    }
    if ((otcPairs && Object.keys(otcPairs).length) && !otcPair) {
      otcPair = otcPairs[revPair];
      if (otcPair) {
        tradeType = 'SELL';
      }
    }

    if (!otcPairs[usePair] && !otcPairs[revPair]) {
      this.setState({pairUnavailable: true});
    }

    let pairData;
    if (otcPair && tradeType) {
      if (tradeType === 'BUY') {
        pairData = {
          pair: usePair,
          humPair: pair[0] + '/' + pair[1],
          tradeType: 'BUY',
          useExchA: pair[0].toLowerCase(),
          useExchB: pair[1].toLowerCase(),
          pairUnavailable: false,
        };
      }
      if (tradeType === 'SELL') {
        pairData = {
          pair: revPair,
          humPair: pair[1] + '/' + pair[0],
          tradeType: 'SELL',
          useExchA: pair[1].toLowerCase(),
          useExchB: pair[0].toLowerCase(),
          pairUnavailable: false,
        };
      }
      this.setState(pairData);
    }
    return pairData;
  }

  promoChange(event) {
    this.setState({
      [event.target.id]: event.target.value,
    });
  }

  amountChange(event) {
    const { exchange } = this.props;
    const { tradeType } = this.state;
    let enteredValue;
    let otherValue;
    let decLength;
    let latestChange;
    let pairPrice;
    if (exchange && exchange.price) {
      pairPrice = exchange.price;
    }
    if (event.target.id) {
      latestChange = event.target.id;
    }
    if (event.target.value) {
      enteredValue = event.target.value;
      if (enteredValue.indexOf('.') !== -1) {
        decLength = enteredValue.split('.')[1].length;
        if (decLength > 8) {
          enteredValue = Number(event.target.value).toFixed(8);
        }
      }
      let tradeSpend;
      let tradeAmount;
      if (tradeType === 'SELL') {
        if (event.target.id === 'tradeAmount') {
          otherValue = Number(event.target.value / pairPrice);
          tradeAmount = enteredValue;
          tradeSpend = otherValue.toFixed(8);
          this.setState({
            tradeAmount,
            tradeSpend,
            latestChange,
            pristine: false,
          });
          this.hasEnoughBalance(tradeSpend, tradeAmount);
          return;
        }
        if (event.target.id === 'tradeSpend') {
          otherValue = Number(event.target.value * pairPrice);
          tradeSpend = enteredValue;
          tradeAmount = otherValue.toFixed(8);
          this.setState({
            tradeSpend: enteredValue,
            tradeAmount: otherValue.toFixed(8),
            latestChange,
            pristine: false,
          });
          this.hasEnoughBalance(tradeSpend, tradeAmount);
          return;
        }
      }

      if (event.target.id === 'tradeAmount') {
        otherValue = Number(event.target.value * pairPrice);
        tradeAmount = enteredValue;
        tradeSpend = otherValue.toFixed(8);
        this.setState({
          tradeAmount: enteredValue,
          tradeSpend: otherValue.toFixed(8),
          latestChange,
          pristine: false,
        });
        this.hasEnoughBalance(tradeSpend, tradeAmount);
        return;
      }

      if (event.target.id === 'tradeSpend') {
        otherValue = Number(event.target.value / pairPrice);
        tradeSpend = enteredValue;
        tradeAmount = otherValue.toFixed(8);
        this.setState({
          tradeSpend: enteredValue,
          tradeAmount: otherValue.toFixed(8),
          latestChange,
          pristine: false,
        });
        this.hasEnoughBalance(tradeSpend, tradeAmount);
        return;
      }
    }
    this.setState({
      [event.target.id]: event.target.value,
    });
    // if (event.target.value) {
    //   value = event.target.value;
    //   if (value.indexOf('.') !== -1) {
    //     decLength = value.split('.')[1].length;
    //     if (decLength > 8) {
    //       value = Number(event.target.value).toFixed(8);
    //     }
    //   }
    // }
    // this.setState({ [event.target.id]: value });
  }

  checkCountdown(type) {
    if (type) {
      this.setState({ countdownExpired: type });
    }
  }

  checkOrder() {
    const { tradeAlt, tradeAmount, tradeSpend, pair, tradeType, latestChange, promoCode } = this.state;
    const { dispatch } = this.props;

    try {
      let match = 'spend';
      let quantity;
      if (latestChange) {
        if (latestChange === 'tradeAmount') {
          quantity = Number(tradeAmount);
          match = 'receive';
        }
        if (latestChange === 'tradeSpend') {
          quantity = Number(tradeSpend);
          match = 'spend';
        }
      }
      if (tradeAlt) {
        let quoteData;
        if (tradeType === 'BUY') {
          quoteData = {
            pair,
            type: tradeType,
            quantity,
            match,
            promoCode,
          };
        }
        if (tradeType === 'SELL') {
          quoteData = {
            pair,
            type: tradeType,
            quantity,
            match,
            promoCode,
          };
        }
        dispatch(fetchQuote(quoteData)).then((res) => {
          if (res.type === 'FETCH_QUOTE_SUCCESS') {
            this.setState({
              tradeStage: 2,
              countdownExpired: false,
              // pristine: true,
            });
          }
        });
      } else {
        let quoteData;
        if (tradeType === 'BUY') {
          quoteData = {
            pair,
            type: tradeType,
            quantity,
            match,
            promoCode,
          };
        }
        if (tradeType === 'SELL') {
          quoteData = {
            pair,
            type: tradeType,
            quantity,
            match,
            promoCode,
          };
        }
        dispatch(fetchQuote(quoteData)).then((res) => {
          if (res.type === 'FETCH_QUOTE_SUCCESS') {
            this.setState({
              tradeStage: 2,
              countdownExpired: false,
              // pristine: true,
            });
          }
        });
      }
    } catch (err) {
      Sentry.captureException(err, scope => {
        scope.setContext("errorOrigin", {origin: "Direct checkOrder catch"});
        scope.setTag("vt_dev", "checkOrder catch");
      });
    }
  }

  submitOrder() {
    const { dispatch, quote } = this.props;
    const { pair, tradeType } = this.state;
    let quantity;
    let quoteID;
    let match;
    if (quote) {
      if (quote.quantity) {
        quantity = quote.quantity;
      }
      if (quote.quoteID) {
        quoteID = quote.quoteID;
      }
      if (quote.match) {
        match = quote.match;
      }
    }
    const data = {
      pair,
      type: tradeType,
      quantity,
      quoteID,
      match,
    };
    this.setState({ pristine: true, submitLoading: true });
    dispatch(createOtcOrder(data))
      .then((res) => {
        if (res.type === 'CREATE_OTC_ORDER_SUCCESS') {
          dispatch(fetchBalance({})).then(res => {
            if (res.type === 'FETCH_BALANCES_SUCCESS') {
              this.setState({ balanceLoading: false });
            }
          });
          this.setState({ tradeStage: 3, submitLoading: false });
        }
        if (res.type === 'CREATE_OTC_ORDER_FAIL') {
          this.setState({ otcFail: true, submitLoading: false });
        }
      });
  }

  editOrder() {
    const { dispatch } = this.props;
    this.setState({
      tradeStage: 1,
      // pristine: true,
      testErrors: {},
      tradeSuccess: false,
      countdownExpired: false,
      otcFail: false,
    });
    dispatch(fetchBalance()).then((res) => {
      if (res.type === 'FETCH_BALANCES_SUCCESS') {
        this.setState({ balanceLoading: false });
      }
    });
  }

  newOrder() {
    const { dispatch } = this.props;
    this.setState({
      tradeStage: 1,
      tradeAmount: '0.000',
      tradeSpend: '0.000',
      // pristine: true,
      testErrors: {},
      tradeSuccess: false,
      countdownExpired: false,
      otcFail: false,
    });
    dispatch(fetchBalance()).then((res) => {
      if (res.type === 'FETCH_BALANCES_SUCCESS') {
        this.setState({ balanceLoading: false });
      }
    });
  }

  isOfType(asset, type) {
    let useAsset;
    if (asset) {
      useAsset = asset.toUpperCase();
    }
    let useType;
    if (type) {
      useType = type.toUpperCase();
    }
    let typeAssets;
    let isType;
    if (AssetConfig && AssetConfig.length) {
      typeAssets = AssetConfig.filter((item) => {
        return item.type === useType;
      });
    }
    if (typeAssets && typeAssets.length) {
      isType = typeAssets.find((item) => {
        return item.handle === useAsset;
      });
    }
    if (isType) {
      return true;
    }
    return false;
  }

  humName(handle) {
    const { assets } = this.props;
    let useAsset;
    let useName = handle;
    if (assets && assets.length) {
      useAsset = assets.find((item) => item.handle === handle.toUpperCase());
    }
    if (useAsset && useAsset.name) {
      useName = useAsset.name;
    }
    return useName;
  }

  availableBalance(type) {
    const { balance, orders, exchange, metal, user } = this.props;
    const { exchA, exchB } = this.state;

    let exchAData;
    let exchAAvailable;
    let maxBalanceA;
    let exchBData;
    let exchBAvailable;
    let maxBalanceB;

    if (balance && balance.data && balance.data.length) {
      exchAData = balance.data.filter((item) => item.handle === exchA.toUpperCase());
      exchBData = balance.data.filter((item) => item.handle === exchB.toUpperCase());
    }
    if (exchAData && exchAData.length) {
      exchAAvailable = exchAData.filter((item) => item.type === 'AVAILABLE');
    }
    if (exchBData && exchBData.length) {
      exchBAvailable = exchBData.filter((item) => item.type === 'AVAILABLE');
    }
    if (exchAAvailable && exchAAvailable[0] && exchAAvailable[0].quantity) {
      maxBalanceA = exchAAvailable[0].quantity;
    }
    if (exchBAvailable && exchBAvailable[0] && exchBAvailable[0].quantity) {
      maxBalanceB = exchBAvailable[0].quantity;
    }

    if (type === 'exchA') {
      return (maxBalanceA);
    }
    if (type === 'exchB') {
      return (maxBalanceB);
    }

    return (Number(0));
  }

  hasEnoughBalance(propSpend, propAmount) {
    const { tradeSpend } = this.state;
    let hasAvailable = false;
    let availableA;
    let useSpend = tradeSpend;
    if (propSpend) {
      useSpend = propSpend;
    }
    if (this.availableBalance('exchA')) {
      availableA = this.availableBalance('exchA');
    }
    let availableB;
    if (this.availableBalance('exchB')) {
      availableB = this.availableBalance('exchB');
    }
    if (useSpend && availableB) {
      hasAvailable = (Number(useSpend) <= Number(availableB));
    }
    this.setState({ availableSpend: hasAvailable });
  }

  currencySign(val) {
    if (val === 'EURCENT') {
      return '\u20AC';
    }
    if (val === 'CENT') {
      return '\u0024';
    }
  }

  takerTiers(feeTaker) {
    const { volume30 } = this.props;

    // let currentTakerData;
    // let tiers;
    // let lowestBound;
    // let currentBound;
    //
    // if ((feeTaker) && (volume30 && volume30[0].value)) {
    //   tiers = feeTaker.filter((x) => x.bound > volume30[0].value);
    //   if (tiers && tiers.length) {
    //     currentBound = Math.min(...tiers.map(item => item.bound));
    //   }
    // }
    //
    // if (currentBound && feeTaker) {
    //   currentTakerData = feeTaker.find(item => item.bound === currentBound);
    // }
    //
    // // if no volume30, or no tiers, show tier 0
    // if ((feeTaker) && (!volume30 || (tiers && (tiers.length < 1)))) {
    //   lowestBound = Math.min(...feeTaker.map(item => item.bound));
    //   currentTakerData = feeTaker.find(item => item.bound === lowestBound);
    // }
    //
    // let usePercentage;
    // if (currentTakerData && currentTakerData.percentage) {
    //   usePercentage = currentTakerData.percentage;
    // }
    const usePercentage = 0.5;

    return (usePercentage);
  }

  getOtcDefaults(asset) {
    const { assets } = this.props;
    let assetData;
    if (assets && assets.length) {
      assetData = assets.find((item) => item.handle === asset.toUpperCase());
    }
    let hasOtc;
    if (assetData && assetData.defaults) {
      hasOtc = assetData.defaults.some((e) => Object.prototype.hasOwnProperty.call(e, 'OTC'));
    }
    let otcDefaults;
    if (hasOtc) {
      otcDefaults = assetData.defaults.find((item) => item.OTC);
      if (otcDefaults.OTC) {
        otcDefaults = otcDefaults.OTC;
      }
    }
    return otcDefaults;
  }

  render() {
    const { user, errors, success, status, metal, exchange, fees } = this.props;
    const { darkModal, sideBar, aAssets, bAssets, exchA, exchB, tradeAlt, tradeAmount, tradeSpend, fiatSelected, tradeType, tradeStage, tradeSuccess, countdownExpired, testDeadline, testLoading, balanceLoading, exchangeLoading, assetPriceLoading, pair, pristine, availableSpend, otcFail, feesLoading, feesFail, latestChange, submitLoading, pairUnavailable, promoCode } = this.state;

    const tradesDisabled = (
      (user && user.me && user.me.flags && user.me.flags.tradesDisabled) &&
      (user.me.flags.tradesDisabled === true)
    ) && (
      (user && user.me && user.me.flags && user.me.flags.verified) &&
      (user.me.flags.verified === true)
    );

    let otcDisabled;

    if (status && status.length) {
      otcDisabled = status.find(x => x.typeHandle === 'otcDisabled');
    }

    let pairFees;
    let feeTaker;

    if (fees && fees.length) {
      pairFees = fees.filter((item) => item.pair === pair);
      feeTaker = pairFees.filter((item) => item.type === 'TAKER');
    }

    const otcLoading = balanceLoading || exchangeLoading || assetPriceLoading || feesLoading;

    if (tradeStage === 3) {
      return (
        <div className="grid-x quick-trade">
          <ToastHandler errors={errors} success={success} />
          <div className="cell panel small-12 medium-10 large-7">
            <SuccessOrder
              exchA={exchA}
              exchB={exchB}
              newOrder={this.newOrder}
            />
          </div>
        </div>
      );
    }

    return (
      <div>
        <div className="grid-x quick-trade">
          <ToastHandler errors={errors} success={success} />
          {this.state.modalComponent &&
            <Modal toggleModal={this.toggleModal} modalComponent={this.state.modalComponent} sideBar={sideBar} darkModal={darkModal} />
          }
          <div className="cell panel small-12 medium-8 large-7">
            { otcLoading ? (
              <div>
                <div className="center-loader">
                  <Loader logo />
                </div>
              </div>
            ) : (
              <div>
                {tradeStage === 1 && (
                  <InitialOrder
                    pairUnavailable={pairUnavailable}
                    tradesDisabled={tradesDisabled}
                    otcDisabled={otcDisabled}
                    tradeType={tradeType}
                    exchA={exchA}
                    exchB={exchB}
                    aAssets={aAssets}
                    bAssets={bAssets}
                    tradeAlt={tradeAlt}
                    tradeAmount={tradeAmount}
                    tradeSpend={tradeSpend}
                    promoCode={promoCode}
                    fiatSelected={fiatSelected}
                    checkOrder={this.checkOrder}
                    assetChange={this.assetChange}
                    amountChange={this.amountChange}
                    promoChange={this.promoChange}
                    availableBalance={this.availableBalance}
                    currencySign={this.currencySign}
                    updateDataLooped={this.updateDataLooped}
                    pristine={pristine}
                    hasEnoughBalance={this.hasEnoughBalance}
                    availableSpend={availableSpend}
                    getOtcDefaults={this.getOtcDefaults}
                    isOfType={this.isOfType}
                    feesFail={feesFail}
                  />
                )}
                {tradeStage === 2 && (
                  <PreviewOrder
                    otcDisabled={otcDisabled}
                    tradesDisabled={tradesDisabled}
                    tradeType={tradeType}
                    exchA={exchA}
                    exchB={exchB}
                    aAssets={aAssets}
                    bAssets={bAssets}
                    tradeAlt={tradeAlt}
                    tradeAmount={tradeAmount}
                    tradeSpend={tradeSpend}
                    fiatSelected={fiatSelected}
                    countdownExpired={countdownExpired}
                    testDeadline={testDeadline}
                    tradeSuccess={tradeSuccess}
                    testLoading={testLoading}
                    newOrder={this.newOrder}
                    submitOrder={this.submitOrder}
                    checkOrder={this.checkOrder}
                    checkCountdown={this.checkCountdown}
                    editOrder={this.editOrder}
                    getQuoteFiat={this.getQuoteFiat}
                    currencySign={this.currencySign}
                    isOfType={this.isOfType}
                    humName={this.humName}
                    feeTaker={feeTaker}
                    takerTiers={this.takerTiers}
                    otcFail={otcFail}
                    pristine={pristine}
                    submitLoading={submitLoading}
                    promoCode={promoCode}
                    toggleModal={this.toggleModal}
                  />
                )}
              </div>
            )}
          </div>
        </div>
        <div className="grid-x quick-trade">
          <div className="cell small-12 medium-10 large-7" style={{ marginBottom: '20px', maxWidth: '650px', textAlign: 'center' }}>
            <small>
              If you have any questions or feedback, please email support at  support@vaultoro.com
            </small>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  orders: state.order,
  errors: state.order.errors,
  success: state.order.success,
  quote: state.order.quote,
  exchange: state.order.exchange,
  metal: state.order.metal,
  balance: state.balance.balance,
  status: state.status.status,
  assets: state.assets.assets,
  pairs: state.assets.pairs,
  fees: state.fees.fees,
  volume30: state.fees.volume30,
});

export default withRouter(connect(mapStateToProps)(Instant));
